import React, {useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Skeleton, Text, Title} from '@optimaxdev/design-system';
import {Coupon, Icon, Question} from '@optimaxdev/icons';
import {useSelector} from 'react-redux';

import {TYP_COUPON_DETAILS, TYP_ORDER_CONFIRMATION_CLICK} from 'constants/analytics/events/typ';

import {
    getIsOneTimeCouponLoading,
    getOneTimeCouponCode,
} from '../../store/selectors/oneTimeCoupon/oneTimeCoupon';

import {OneTimeCouponModal} from './modal/oneTimeCouponModal';

import s from './oneTimeCouponOffer.scss';

const sendShopNowAnalyticEvent = () => sendDesktopAnalyticsEvent(TYP_ORDER_CONFIRMATION_CLICK);

/**
 * One time coupon offer in TYP
 */
export const OneTimeCouponOffer = () => {
    const [showCouponModal, setShowCouponModal] = useState(false);
    const isLoading = useSelector(getIsOneTimeCouponLoading);
    const couponCode = useSelector(getOneTimeCouponCode);

    if (isLoading) return <Skeleton height={97} radius={12} />;

    if (!couponCode) return null;

    const onOpenInformationClick = () => {
        setShowCouponModal(true);
        sendDesktopAnalyticsEvent(TYP_COUPON_DETAILS);
    };

    return (
        <>
            <section className={s.card}>
                <div className={s.wrapper}>
                    <Icon
                        className={s.couponIcon}
                        color={Colors.blueCharcoal}
                        icon={Coupon}
                        strokeWidth={2}
                    />
                    <Title color={Colors.blueCharcoal} level={4} margin="0 0 4px 0">
                        $15 off your next purchase.
                    </Title>
                    <Text as="p" color={Colors.limedSpruce} lineHeight="24px" size="16px">
                        Hurry, valid for 24 hours only.{' '}
                        <span className={s.couponCode}>
                            Code: {couponCode}
                            <button
                                aria-label="Open information about special coupon"
                                className={s.couponQuestionIcon}
                                onClick={onOpenInformationClick}
                                type="button"
                            >
                                <Icon icon={Question} />
                            </button>
                        </span>
                    </Text>
                </div>
                <a className={s.shopNowLink} href="/" onClick={sendShopNowAnalyticEvent}>
                    Shop Now
                </a>
            </section>

            <OneTimeCouponModal
                couponCode={couponCode}
                onClose={() => setShowCouponModal(false)}
                showCouponModal={showCouponModal}
            />
        </>
    );
};
